export default {
  queue: {
    created: 'New task created.',
    batchCreated: 'Batch tasks created.',
    next: 'Next task processing.',
    starting: 'Queue listener starting.',
    stopping: 'Queue listener stopping.',
    stopped: 'Queue listener stopped.',
    empty: 'channel is empty...',
    'not-found': 'worker not found',
    offline: 'Disconnected',
    online: 'Connected',
  },

  event: {
    created: 'event created',
    fired: 'Event fired.',
    'wildcard-fired': 'Wildcard event fired.',
  },
};
